import type { FaireProductEntity } from "../../entity_types/product";

export const p_uj9zeufq55: FaireProductEntity = {
  token: "p_uj9zeufq55",
  type: "product",
  name: "CWMM10459_FOOTBALL MOM GAME DAY BEADED ELASTIC BRACELET",
  brandToken: "b_gd86yguu29",
  brandName: "NINEXIS",
  imageUrl:
    "https://cdn.faire.com/fastly/f0e67c67ab2779af98395ad6096643813df8c63d1aaf9806a849c3e78bb649b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27771d72a48e4902cd891366b5f7dcbb7032969f94312af880f05489672dfc71.jpeg",
    "https://cdn.faire.com/fastly/d817b68e836f61d2f726b4bb40e35378c0421cab0679ed8a88e05c1f9f2e9794.jpeg",
    "https://cdn.faire.com/fastly/0ab9d0067aed1e5759f6ad6a5ec1aa2fc2cea458464598d73c9f6c69b2228679.jpeg",
    "https://cdn.faire.com/fastly/17ee6eaca39dbf3082c08de0f3bf0e3bece05623061cf6348526b79071415063.jpeg",
    "https://cdn.faire.com/fastly/940cc682c358c38540be5a976633d2ba4a6e65d1c4c1ffd0b050c8e5d4dc7ccb.jpeg",
    "https://cdn.faire.com/fastly/106e59918d31525b496c53ecf0f9a605fe9b94ffd293a68a86bebf35a206c5df.jpeg",
    "https://cdn.faire.com/fastly/f1be1d1f9cec0a7642b701a6bd62b2074f734831113d8d7e7061cde149795b25.jpeg",
    "https://cdn.faire.com/fastly/4f1fe65a04bffdeb406d1a2469de286082d4a9e069f0c04e0e1b675d2e9a297a.jpeg",
    "https://cdn.faire.com/fastly/4a1f30a7f712c7d2212e66f0afb165b8a3f69a1c946609151a8e5dee945ff529.jpeg",
    "https://cdn.faire.com/fastly/951ab9a8a0c514e4c60be1ee89de1b86574e3928e084d487e825ac52699f8824.jpeg",
    "https://cdn.faire.com/fastly/9c7623a2416a50508cf38cb094a69879daffee15a2460c7a2f07129dcace2535.jpeg",
  ],
  priceDollars: 4.16,
  description:
    "FOOTBALL MOM GAME DAY BEADED ELASTIC BRACELET\n100% POLYMER CLAY\nSIZE  ONE SIZE \nELASTIC :DIAMETER: 2.36\"(6 CM)\nMADE IN CHINA \n\nBOHEMIAN BEADED BRACELET, STRETCH BEAD BRACELET, BOHEMIAN JEWELRY,HEART BEAD BRACELET, LOVE CHARM BRACELET, ADJUSTABLE BEADED BRACELET,4-PACK BRACELET SET, ELASTIC BRACELET, NATURAL STONE BRACELET , ALLOY BRACELET,STACKABLE BRACELETS FOR WOMEN, BOHO CHIC GIFT SET, FESTIVAL JEWELRY,FRIENDSHIP GIFT SET, SUMMER BOHO STRETCH BRACELETS, MINIMALISTIC HEART BRACELET SET,BRACELET FOR WOMEN, WOMEN'S BRACELET, WRISTBAND,BEADED BRACELET, STRETCH BRACELET, CRYSTAL BRACELET, CHARM BRACELET,GEMSTONE BRACELET, PEARL BRACELET, GOLD PLATED BRACELET, LEATHER BRACELET,MINIMALIST BRACELET, VINTAGE BRACELET, YOGA BRACELET,STACKING BRACELETS, FRIENDSHIP BRACELET, GIFT FOR HER, EVERYDAY JEWELRY",
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:25.529Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
